module.exports = __webpack_public_path__ + "media/promo/promo/images/top-bg-8aba07c4ddc011be219c62ff0d79bfe5.png";